import { hydrate } from '@wagmi/core';
export const configKey = Symbol();
export const WagmiPlugin = {
    install(app, options) {
        const { config, reconnectOnMount = true } = options;
        app.provide(configKey, config);
        // TODO: check this works in SSR env.
        //       - reconnect on mount.
        //       - hydrate initial state.
        const { onMount } = hydrate(config, { ...options, reconnectOnMount });
        onMount();
    },
};
//# sourceMappingURL=plugin.js.map